"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const dayjs_1 = __importDefault(require("dayjs"));
const debounce_1 = __importDefault(require("lodash/debounce"));
const timeago_js_1 = require("timeago.js");
const HelperUtils_1 = require("utils/HelperUtils");
const ModalImage_1 = __importDefault(require("components/shared/ModalImage/ModalImage"));
const ATTACHMENT_ELEMENT_ID = 'attachment';
const charWidthCalculate = (text) => {
    const totalShortChar = ((text === null || text === void 0 ? void 0 : text.match(/[il,;:'|!`*]/g)) || []).length * 0.6;
    const totalSpaceChar = ((text === null || text === void 0 ? void 0 : text.match(/\s/g)) || []).length * 0.05;
    const totalLargeChar = ((text === null || text === void 0 ? void 0 : text.match(/(?![IMW])[A-Z]/g)) || []).length * 0.4;
    const totalXLargeChar = ((text === null || text === void 0 ? void 0 : text.match(/[mw]/g)) || []).length * 0.25;
    const totalXXLargeChar = ((text === null || text === void 0 ? void 0 : text.match(/[MW]/g)) || []).length * 0.55;
    return (text.length -
        totalShortChar +
        totalLargeChar +
        totalXLargeChar +
        totalXXLargeChar +
        totalSpaceChar);
};
const RecentActivity = ({ actorName, progresses, comment, attachments, dateActivity, isCommentOpen, setCommentOpen, isEmpty, id }) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const _debounced = (0, react_1.useCallback)((0, debounce_1.default)((action) => action(), 1000), []);
    const [isOpenModalImage, setIsOpenModalImage] = (0, react_1.useState)(false);
    const frRef = (0, react_1.useRef)(null);
    const actorSpan = `<span class='text-n-900 typography-h200'>${actorName}</span>`;
    const progressesSpan = progresses
        ? `updated progress from <span class='text-n-900 typography-h200'>${progresses.previousValue}</span> to <span class='text-n-900 typography-h200'>${progresses.currentValue}</span>`
        : '';
    const commentConj = progresses ? 'with comment' : 'commented';
    const commentSpan = comment
        ? `${commentConj} <span class='text-n-900 typography-h200 italic' id='comment'>"${comment}"</span>`
        : '';
    const attachmentHref = (attachments === null || attachments === void 0 ? void 0 : attachments.type) != 'image' && (attachments === null || attachments === void 0 ? void 0 : attachments.state) == 'available'
        ? `href='${attachments.downloadUrl}' download`
        : '';
    const attachmentSpan = attachments
        ? `with attachment <a class="text-base-600 typography-h200 cursor-pointer" id="${ATTACHMENT_ELEMENT_ID}" ${attachmentHref}>${attachments === null || attachments === void 0 ? void 0 : attachments.name}</a> `
        : '';
    const activitySet = isEmpty
        ? `<span class='text-n-600 typography-h200 italic' id='comment'>There's no recent activity yet</span>`
        : `${actorSpan} ${progressesSpan} ${commentSpan} ${attachmentSpan}`;
    const formattedDateActivity = (0, dayjs_1.default)(dateActivity).format('d MMM YYYY HH:mm');
    const dateFromNow = dateActivity ? (0, timeago_js_1.format)(dateActivity) : '';
    const commentToggle = (e) => {
        e.stopPropagation();
        if (isCommentOpen)
            return;
        setCommentOpen(true);
    };
    const onClickHandler = (e) => {
        e.stopPropagation();
        const target = e.target;
        if ((attachments === null || attachments === void 0 ? void 0 : attachments.type) != 'image' || (attachments === null || attachments === void 0 ? void 0 : attachments.state) != 'available')
            return;
        if (target.tagName != 'A')
            return;
        if (target.id != ATTACHMENT_ELEMENT_ID)
            return;
        setIsOpenModalImage(true);
    };
    const handleTruncation = (0, react_1.useCallback)((element) => {
        var _a;
        const currentWidth = ((_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0;
        const fontSize = 12;
        const fontConstant = 1.9;
        const charPerLine = Math.ceil(currentWidth / (fontSize / fontConstant));
        const maxChar = charPerLine * 2;
        const elementChildren = element.children;
        const actualTotalChar = charWidthCalculate(element.textContent || '');
        for (const el of elementChildren) {
            if (el.id != 'comment')
                continue;
            if (isEmpty) {
                el.innerHTML = "There's no recent activity yet";
                break;
            }
            const commentFromElement = el.textContent;
            const CFELength = charWidthCalculate(commentFromElement || '');
            const commentLength = charWidthCalculate(comment || '');
            const charWithoutComment = actualTotalChar - CFELength;
            const expectedTextContentLength = charWithoutComment + commentLength + 2;
            let designatedComment = comment;
            if (expectedTextContentLength > maxChar) {
                const charDiff = expectedTextContentLength + 6 - maxChar;
                const trimmed = comment === null || comment === void 0 ? void 0 : comment.substring(0, Math.round(Math.abs((commentLength || 0) - charDiff)));
                const trimmedLength = charWidthCalculate(trimmed || '');
                const currentTrimmedLength = trimmedLength + charWithoutComment;
                if (currentTrimmedLength > maxChar) {
                    designatedComment =
                        (comment === null || comment === void 0 ? void 0 : comment.substring(0, ((trimmed === null || trimmed === void 0 ? void 0 : trimmed.length) || 0) - (currentTrimmedLength - maxChar))) + '...';
                }
                else {
                    designatedComment = trimmed + '...';
                }
            }
            el.innerHTML = `"${designatedComment}"` || '';
            break;
        }
        element.classList.remove('hidden');
    }, [comment, isEmpty]);
    (0, react_1.useEffect)(() => {
        if (!frRef.current)
            return;
        const element = frRef.current;
        const resizeContent = new ResizeObserver((e) => {
            for (const el of e) {
                _debounced(() => handleTruncation(el.target.children[0]));
            }
        });
        if (!element.parentElement)
            return;
        resizeContent.observe(element.parentElement);
        return () => {
            if (!element.parentElement)
                return;
            resizeContent.unobserve(element.parentElement);
        };
    }, [handleTruncation, _debounced]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", { ref: frRef, onClick: onClickHandler, dangerouslySetInnerHTML: { __html: activitySet }, className: "typography-h100 text-n-800 hidden break-words", "data-cy": `recent-activity-${id}` }),
        react_1.default.createElement("p", { className: "mt-[8px] typography-h100 text-n-600" },
            !isEmpty && (react_1.default.createElement(react_1.default.Fragment, null,
                formattedDateActivity,
                " \u00B7 ",
                dateFromNow,
                " \u00B7",
                ' ')),
            react_1.default.createElement("span", { onClick: commentToggle, className: `${!isCommentOpen ? 'text-base-600' : ''} typography-h100`, "data-cy": `open-comment-activity-${id}` }, (0, HelperUtils_1.getObjectiveLocale)('Comment'))),
        react_1.default.createElement(ModalImage_1.default, { imgs: [{ src: attachments === null || attachments === void 0 ? void 0 : attachments.downloadUrl }], isOpen: isOpenModalImage, onClose: () => setIsOpenModalImage(false) })));
};
exports.default = RecentActivity;
